import { render, staticRenderFns } from "./IconBadgeCheckOutline.vue?vue&type=template&id=b57a330a"
import script from "./IconBadgeCheckOutline.vue?vue&type=script&lang=js"
export * from "./IconBadgeCheckOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports